import React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { Box, Heading, Icon, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { RENTER_CANNOT_IDV_HELP_URL } from '../../../constants/urls';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';
import { ExitReason } from '../../../../../models';

interface ForbiddenIpProps {
  id: string;
}

export default function ForbiddenIp({ id }: ForbiddenIpProps) {
  const { currentSubStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.ForbiddenIp, success: false });
      }}
      render={() => (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', alignItems: 'flex-start' }}>
          <Icon size="lg" css={{ color: 'icon.neutral' }}>
            <IconRateUnhappyFilled />
          </Icon>
          <Heading level={2} textStyle="heading-sm">
            We can’t complete your request
          </Heading>
          <Paragraph>
            It looks like you’re logged in from an IP address we don’t support, such as an international IP address or
            private server. You will not be able to ID verify.
          </Paragraph>
          <Paragraph>
            If you have access to a valid U.S. IP address or VPN (military or employer-provided), please connect to it
            to continue.
          </Paragraph>
          <TextButton asChild>
            <a href={RENTER_CANNOT_IDV_HELP_URL} target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          </TextButton>
        </Box>
      )}
    />
  );
}
